import axiosClient, { app_uri } from "../../../utils/axiosFactory";
import { BookingClient } from "../../parentApi";

const client = new BookingClient(app_uri, axiosClient());

export default client;
